<div (click)="getAndOpenRecoveryPaymentDocument(recoveryPaymentDocumentId)">
  <img class="icon open-icon" src="/assets/icons/open_new_page.svg" alt='manage recovery payment'>
</div>
